var _text, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKenari(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    role: "img",
    "aria-label": "kenari",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 365,
    textAnchor: "start",
    fontFamily: "Archivo, system-ui, sans-serif",
    fontSize: 330,
    fontWeight: 800,
    letterSpacing: "-0.06em",
    fill: "currentColor"
  }, "k")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 309,
    width: 56,
    height: 56,
    fill: "currentColor",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenari);
export default __webpack_public_path__ + "static/media/kenari.653c148c2242146b2d5f409c076491ea.svg";
export { ForwardRef as ReactComponent };